import React from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";
import moment from "moment";
import Config from "../../Config";

import {
    gTypeOfRoles
} from "../../Config";

const RoleViewModel = ({ setopenRoleViewModel, selectedItem }) => {
  //console.log(selectedItem)
  const parseRoles = (selectedItem) => {
    if (selectedItem == "")
      return 'NA';
    var roles = '';
    selectedItem.split(',').map((ln, i) => {
      const selectedItem = gTypeOfRoles.find(item => item.value == ln);
      if (roles == '')
      roles = selectedItem.label;
      else
      roles = roles + ", " + selectedItem.label;
    })
    return roles;
  }
  return (
    <Model width={"w-8/12 max-w-2xl"} setOpenModel={setopenRoleViewModel}>
      <Wrapper>
        <Title>Assigned Roles</Title>
        <SingleItem name={""} value={parseRoles(selectedItem)} />
       
      
      </Wrapper>
    </Model>
  );
};

const SingleItem = ({ name, value, link, url }) => (
  <div className="flex items-center py-2 border-b border-gray-100 ">
    {/* <Name>{name}</Name> <p className="w-10">:</p> */}
    {link && (
      <LinkValue href={url} target="_blank" title="Click to open">
        {value}
      </LinkValue>
    )}
    {!link && <Value>{value}</Value>}
  </div>
);

const Wrapper = tw.div`px-4`;
const Title = tw.h2`text-lg md:text-xl mb-6 text-gray-700 font-medium text-left`;
const Name = tw.p`text-sm text-gray-500  w-40`;
const Value = tw.p`text-sm text-gray-800 font-medium max-w-xs `;
const LinkValue = tw.a`text-sm text-blue-500 max-w-xs truncate cursor-pointer`;
export default RoleViewModel;
